import { render, staticRenderFns } from "./ManageOrganisations.vue?vue&type=template&id=2a8156b4"
import script from "./ManageOrganisations.vue?vue&type=script&lang=ts"
export * from "./ManageOrganisations.vue?vue&type=script&lang=ts"
import style0 from "./ManageOrganisations.vue?vue&type=style&index=0&id=2a8156b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports